import { error, finish } from '../../../../modules/ladders/actions/masterLadder/createPrice';

export function request(dispatch, { price }) {
    $appState.sdkStaff.trading.createPriceStepInPriceLadder(price)
        .then(data => dispatch(finish(data)))
        .catch(errors => dispatch(error(errors)));
}
